<template>
    <div class="aboutUs">
        <div class="logo" :style="{backgroundImage: 'url(' + getpath('newapplogo','.png') + ')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}"></div>
        <div class="version">版本号 {{edition}}</div>
        <!-- <div class="qrcode">
            <div class="code1">
                <div class="imgbox" :style="{backgroundImage: 'url(' + getpath('qrcode','.jpg') + ')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}"></div>
                <div class="txt">关注Uummii的公众号 了解更多精彩活动</div>
                <div class="txt">如有问题，请联系客服：13681042753</div>
            </div>
        </div> -->
        <div class="link"> 
            <span class="linkitem" @click="go(17)">《用户注册协议》</span><span>、</span>
            <span class="linkitem" @click="go(18)">《用户隐私政策》</span><span>、</span>
            <span class="linkitem" @click="go(16)">《儿童隐私政策》</span>
        </div>

        <p class="copyright">©2022 Stage Kids All Rights Reserved</p>
    </div>
</template>

<script>
import { getImagePath } from "@/config/imgConfig";
export default {
    name:'aboutUs',
    data(){
        return {
            title:'',
            edition:''
        }
    }, 
    created() {
        var json = JSON.stringify({
            path: this.$route.fullPath
        });
        window.localStorage.setItem("json", json);

        var str = this.version;
        this.edition = 'v'+str;
    },
    mounted(){
        document.title = '关于我们';
    },
    methods:{
        go(type){
            this.$router.push({
                path:'/userAgree?type='+type
            })
        },
        getpath(name,type){
            return getImagePath(name,type,false)
        }
    }
}
</script>

<style lang="scss" scoped>
    .aboutUs{
        width: 100%;
        height: 100%;
        padding-top: 20%;
        .logo{
            width: 112.5px;
            height: 112.5px;
            margin: 0% auto 20px;
        }
        .version{
            text-align: center;
            font-size:15px;
            font-family:PingFang-SC-Medium,PingFang-SC;
            font-weight:500;
            color:rgba(0,15,65,1);
            line-height:100px;
        }
        .link{
            width: 100%;
            position: absolute;
            bottom: 50px;
            display: flex;
            flex-flow:row wrap;
            justify-content: center;
            span{
                font-size:13px;
                font-family:PingFang-SC-Medium,PingFang-SC;
                font-weight:500;
                text-align: center;
                color:#434665;
                line-height:50px;
                &.linkitem{
                    text-decoration: underline;
                }
            }

        }
        .qrcode{
            width: 80%;
            min-height: 100px;
            margin: 50px auto 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .code1{
                width: 100%;
                height: 100%;
                .imgbox{
                    width:107.5px;
                    height: 107.5px;
                    margin: 0 auto;
                }
                .txt{
                    font-size:13px;
                    font-family:PingFang-SC-Medium,PingFang-SC;
                    font-weight:500;
                    text-align: center;
                    color:rgba(108,127,155,1);
                    line-height:40px;
                }
            }
        }
        .copyright{
            width: 100%;
            position: absolute;
            bottom: 20px;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
            color: #797e93;
            line-height: 33px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/cUser/aboutUs.vue